<ng-container *ngIf="viewport.isMobile(); else desktopAlert">
  <div
    class="m-toast"
    [class.success]="alertType === alertTypes.SUCCESS"
    [class.error]="alertType === alertTypes.ERROR"
    [class.warning]="alertType === alertTypes.WARNING"
    [class.info]="alertType === alertTypes.INFO"
  >
    <div class="m-toast__icon">
      <ng-container [ngSwitch]="alertType">
        <svg
          *ngSwitchCase="alertTypes.SUCCESS"
          class="m-toast__glyph"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M5 12.5l4.2 4.2L19 7"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          *ngSwitchCase="alertTypes.ERROR"
          class="m-toast__glyph"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M7 7l10 10M17 7L7 17"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          *ngSwitchCase="alertTypes.WARNING"
          class="m-toast__glyph"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M12 6v8.5"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
          />
          <circle cx="12" cy="18.5" r="1.3" fill="currentColor" />
        </svg>
        <svg
          *ngSwitchCase="alertTypes.INFO"
          class="m-toast__glyph"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <circle cx="12" cy="6.5" r="1.3" fill="currentColor" />
          <path
            d="M12 10.5v8"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
          />
        </svg>
      </ng-container>
    </div>
    <div class="m-toast__message">{{ message }}</div>
    <div class="m-toast__actions">
      <button
        type="button"
        class="m-toast__copy"
        (click)="copy(); $event.stopPropagation()"
      >
        <span [class]="copied ? 'ui-icon-checkmark' : 'ui-icon-copy1'"></span>
      </button>
      <button type="button" class="m-toast__close" (click)="action()">
        <span class="ui-icon-close"></span>
      </button>
    </div>
  </div>
</ng-container>

<ng-template #desktopAlert>
  <ui-alert
    class="custom-toast-alert"
    [type]="alertType"
    [visible]="true"
    [closable]="true"
    [title]="title"
    (closeAction)="action()"
    (mouseleave)="mouseout()"
    (mouseover)="mouseover()"
  >
    <span>{{ message }}</span>
  </ui-alert>
</ng-template>
